// extracted by mini-css-extract-plugin
export default {"SectionTitleDivs":"SeaLevelRise_SectionTitleDivs__uhCX+","SectionLabels":"SeaLevelRise_SectionLabels__Lp7Cz","Label":"SeaLevelRise_Label__wTODk"};